import React, {useEffect, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useHistory, useParams} from "react-router-dom";
import {disableBodyScroll, enableBodyScroll} from "body-scroll-lock";

//helpers:
import {useWindowSize} from "../../../../_helpers";

//actions:
import {queryActions} from "../../../../../app/redux/Query/queryRedux";
import {getVideos} from "../../../../../app/redux/Settings/homePageSlice";

//components:
import {CustomTooltip} from "../../../../../app/widgets/index";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";

import {connectSearchBox} from "react-instantsearch-dom";
import Tour from "reactour";
import {updateParameters} from "../../../../../app/redux_slices/userParametersSlice";

const style = {
    floating: {
        position: "absolute",
        background: "white",
        width: "100%",
        height: 135,
        padding: 0,
        left: 0,
        right: 0,
        top: 65,
        display: "flex",
        alignItems: "center",
    },
};

export const SearchBar = () => {
    const {t} = useTranslation();

    const windowSize = useWindowSize();
    const {level_id} = useParams();
    const history = useHistory();

    //redux
    //store:
    const trackName = useSelector(state => state.layout.trackName);
    const isHome = useSelector(state => state.layout.isHome);
    const credentialSelector = useSelector(state => state.context.credential);
    const contextChallenges = useSelector(state => state.context?.challenges);
    const tracks = useSelector(state => state.tracks.normalTracks);

    //actions:
    const dispatch = useDispatch();

    //local state:
    const [isTourOpen, setIsTourOpen] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(null);
    const [searchBarPlaceholder, setSearchBarPlaceholder] = useState("");
    const [isDesktop, setIsDesktop] = useState(false);

    useEffect(() => {
        dispatch(getVideos());
    }, []);

    useEffect(() => {
        if (!credentialSelector.tours?.home && !contextChallenges.length) {
            setIsTourOpen(true);
            dispatch(updateParameters({values: {tours: {...(credentialSelector.tours ?? {}), home: true}}}));
        }
    }, []);

    useEffect(() => {
        const width = windowSize.width;
        const _isDesktop = width > 991;
        setIsDesktop(_isDesktop);
    }, [windowSize]);

    useEffect(() => {
        let placeholder = t("HEADER.SEARCHBAR.PLACEHOLDER.HOME");

        if (level_id) {
            const thisTrack = t("HEADER.SEARCHBAR.THIS_TRACK");

            placeholder = t("HEADER.SEARCHBAR.PLACEHOLDER.TRACKPAGE", {
                trackName: trackName || thisTrack,
            });
        }

        setSearchBarPlaceholder(placeholder);
    }, [t, level_id, trackName]);

    const handleClick = event => {
        setPopoverOpen(!popoverOpen);
    };

    let currentTimeout;
    const CustomSearchBar = connectSearchBox(({currentRefinement, refine}) => {
        return (
            <div className="searchBar d-none d-sm-flex tour-searchbar">
                <div className="rounded shadow overflow-hidden m-auto border border-white w-100">
                    <div className="input-group input-group h-45px">
                        <div className="input-group-prepend w-40px ">
                            <SearchIcon
                                className="text-muted m-auto cursor-pointer text-hover-white font-size-1_8rem"
                                onClick={() => currentRefinement && dispatch(queryActions.setShowResults(true))}
                            />
                        </div>

                        <input
                            className="form-control border-0 pl-3 pr-1 h-45px border-0 bg-transparent text-white"
                            placeholder={searchBarPlaceholder}
                            type="text"
                            onChange={e => {
                                const value = e.currentTarget.value;
                                if (value === "") {
                                    refine("");
                                } else {
                                    refine("\"" + value.replaceAll("\"", "") + "\"");
                                }
                            }}
                        />

                        <div className="input-group-append">
                                <span className="input-group-text border-0 py-0 px-3 bg-transparent">
                                {/* <ResultsCount query={currentRefinement} /> */}

                                    {false ?
                                        <CloseIcon
                                            className="text-muted text-hover-white cursor-pointer"
                                            onClick={() => refine("")}
                                        /> : null}
                                    {isHome ? <CustomTooltip
                                        config={{
                                            text: "Know more...",
                                            placement: "bottom",
                                        }}
                                    >
                                        <div
                                            onClick={() => setIsTourOpen(true)}
                                            className="d-flex btn btn-icon pulse pulse-white h-100 pl-5 pr-4"
                                        >
                                            <HelpOutlineIcon className="text-muted text-hover-white" />
                                            <span className="pulse-ring text-white" />
                                        </div>
                                    </CustomTooltip> : null}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    const ResponsiveSearchBar = connectSearchBox(({currentRefinement, refine}) => (
        <input
            type="text"
            className="form-control border-0 p-5"
            style={{fontSize: 20, height: 135}}
            placeholder={searchBarPlaceholder}
            // value={currentRefinement}
            onChange={e => {
                refine(e.currentTarget.value);
            }}
        />
    ));

    const steps = [
        {
            selector: ".tour-topbanner .swiper-container",
            content: t("TOURS.HOMEPAGE.1"),
            position: "center",
        },
        {
            selector: "#tour-profile",
            content: t("TOURS.HOMEPAGE.2"),
        },
        {
            selector: ".helpcrunch-iframe-wrapper iframe",
            content: t("TOURS.HOMEPAGE.3"),
        },
        {
            selector: ".tour-component",
            content: t("TOURS.HOMEPAGE.4"),
        },
        {
            selector: ".tour-searchbar",
            content: t("TOURS.HOMEPAGE.5"),
        },
        {
            selector: ".tour-trackbutton",
            content: t("TOURS.HOMEPAGE.6"),
        },

        // ...
    ];
    return useMemo(() => (
        <>
            {isDesktop ? (
                <CustomSearchBar />
            ) : (
                <div className="d-flex align-items-center ml-auto mr-0">
                    <div className="d-flex h-45px w-45px cursor-pointer">
                        {!popoverOpen ? (
                            <button className={"btn btn-hover-transparent-white"} onClick={handleClick}>
                                <SearchIcon className="text-muted m-auto text-hover-white font-size-1_8rem" />
                            </button>
                        ) : (
                            <button className={"btn btn-hover-transparent-white btn-light"} onClick={handleClick}>
                                <CloseIcon className="text-muted m-auto text-hover-white font-size-1_8rem" />
                            </button>
                        )}
                    </div>
                    {popoverOpen ? (
                        <div style={style.floating}>
                            <SearchIcon className="text-muted pl-4 pr-2" style={{width: 42, height: 42}} />
                            <ResponsiveSearchBar />
                        </div>
                    ) : null}
                </div>
            )}

            <Tour
                steps={steps}
                isOpen={isTourOpen}
                onRequestClose={() => setIsTourOpen(false)}
                onAfterOpen={target => disableBodyScroll(target)}
                onBeforeClose={target => enableBodyScroll(target)}
                scrollDuration={100}
                rounded={15}
                disableInteraction={true}
                closeWithMask={false}
                lastStepNextButton={<button className={"btn btn-primary"} onClick={() => {
                    const firstTrack = tracks[0].track_id;
                    history.push(`/track/${firstTrack}#tour`);
                }}>Ver Track page</button>}
            />
        </>
    ), [isTourOpen, popoverOpen, isDesktop]);
};
